import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  linearGradient: {
    flex: 1,
  },
});
